import { Environment } from '../env/Environment';
import { clearSession, storeTokens } from '../utils/auth/session-storage';
import { MAIN_REDIRECT } from '../utils/constants';
import { Cornerstone } from '@rpi/api';
import { LoaderFunction, redirect } from 'react-router-dom';
import { z } from 'zod';

export const signOutLoader: LoaderFunction = async ({ request }) => {
  await Cornerstone.logout();

  clearSession();

  const url = new URL(request.url);
  return redirect(`/auth/sign-in${url.search}`);
};

export const registrationLoader: LoaderFunction = async ({
  request,
  params,
}) => {
  const url = new URL(request.url);
  const newSearchParams = url.searchParams;
  const token = params.token;
  try {
    // adding baseURL to the request because the base url is not getting set prior to this backend call
    const response = await Cornerstone.confirmSignupRegistration(
      z.string().uuid().parse(token),
      {
        baseURL: Environment.API.URL.BLURBCORE,
      },
    );

    storeTokens(response.data.accessToken, response.data.refreshToken);
  } catch (error) {
    const errorCode = (error as any)?.response?.data?.errorCode as
      | string
      | undefined;
    if (errorCode === Cornerstone.ErrorCode.USER_REGISTRATION_TOKEN_NOT_FOUND) {
      return redirect(
        `/auth/sign-up/confirm/verification-expired?${newSearchParams.toString()}`,
      );
    } else if (errorCode === Cornerstone.ErrorCode.USER_ALREADY_REGISTERED) {
      newSearchParams.set('alreadyRegistered', 'true');
      return redirect(`/auth/sign-in?${newSearchParams.toString()}`);
    } else {
      throw error;
    }
  }

  newSearchParams.set('registered', 'true');
  return redirect(`${MAIN_REDIRECT}?${newSearchParams.toString()}`);
};
